import axios from 'axios'
import { createClient } from '@supabase/supabase-js'

const MSWApiURL = process.env.REACT_APP_EXAMPLE_API_URL
// 개발 환경에서는 프록시 사용 (GET만), 프로덕션에서는 상대 경로
const apiURL = process.env.NODE_ENV === 'development' ? '' : ''
const supaBaseURL = process.env.REACT_APP_API_SUPA_BASE_API_URL

// 일반 API용 헤더
export const apiHeaders = {
    'Content-Type': 'application/json',
}

// Supabase API용 헤더
export const defaultHeaders = {
    prefer: 'return=representation',
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache', // 자체 캐쉬 처리되어 실제 서버를 호출하지 않는 현상 해결
    apikey: process.env.REACT_APP_SUPABASE_KEY,
    Authorization: `Bearer ${process.env.REACT_APP_SUPABASE_KEY}`,
}

export const createCustomInstance = (customURL, config) => {
    return axios.create({
        baseURL: customURL,
        headers: config,
        timeout: 5000, // 시간이 오래 걸리는 요청에 대한 timeout 값 재정의, 5초
    })
}
// MSW API
export const mockInstance = createCustomInstance(MSWApiURL, apiHeaders)

// backend API
export const instance = createCustomInstance(apiURL, apiHeaders)

// 슈퍼베이스 API
export const supaBaseInstance = createCustomInstance(supaBaseURL, defaultHeaders)

// 슈퍼베이스 API 클라이언트
const supabaseUrl = process.env.REACT_APP_API_SUPA_BASE_API_URL
const supabaseKey = process.env.REACT_APP_SUPABASE_KEY
export const supabase = createClient(supabaseUrl, supabaseKey)

// 개발 환경에서는 프록시 사용으로 withCredentials 불필요
if (process.env.NODE_ENV !== 'development') {
    instance.defaults.withCredentials = true // 쿠키값 전달 허용 전역 선언
}
